export enum PartnerTheme {
  BLUE = 'BLUE',
  OPAL = 'OPAL',
}
